import { IVenueBrief, IVenueSelectorListItem, ProblemDetails, ResponseWrapper, WorkspaceHourlyModel, WorkspaceModel, WorkspacePeriodModel } from "Services/API/API";

export function isVenueBrief(venue: IVenueBrief | IVenueSelectorListItem): venue is IVenueBrief {
   return (venue as IVenueBrief).isVenueBrief === true;
}

export function isResponseWrapper(obj: unknown): obj is ResponseWrapper {
   return (obj as ResponseWrapper)?.isResponseWrapper === true;
}

export function isWorkspaceHourlyModel(obj: WorkspaceModel): obj is WorkspaceHourlyModel {
   return obj["_discriminator"] === "WorkspaceHourlyModel";
}

export function isWorkspacePeriodModel(obj: WorkspaceModel): obj is WorkspacePeriodModel {
   return obj["_discriminator"] === "WorkspacePeriodModel";
}

export function isLegacyException(obj: unknown): obj is LSCommon.ServerErrorJsonResponse {
   return !!(obj as LSCommon.ServerErrorJsonResponse)?.isException;
}

export function isReactKey(obj: unknown): obj is React.Key {
   const objType = typeof obj;
   return objType === "number" || objType === "string";
}

export function isProblemDetails(obj: unknown): obj is ProblemDetails {
   return obj instanceof ProblemDetails;
}